import { StatsAdapterInterface } from '../../../stats/adapter.interface';
import { StatsContextInterface } from '../../../stats/context.interface';

export class GtmStatsAdapterLanguage implements StatsAdapterInterface {
  /**
   * Mapping language identifier to language label
   */
  private mapping: { [key: string]: string } = {
    en: 'English',
    ar: 'Arabic',
    fr: 'French',
  };

  /**
   *
   * @param context
   */
  constructor(protected context: StatsContextInterface) {}

  /**
   * @inheritDoc
   */
  public getData(): string {
    return this.mapping[this.context.global.language.toLowerCase()] || '';
  }
}
